import useResizeObserver from '@react-hook/resize-observer';
import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Key } from 'w3c-keys';
import { Horizontal, Vertical } from '../../../../../layout';
import { Link } from '../../../../../link/link';
import { isHTML, SafeHTML } from '../../../../../safe-html/safe-html';
import { Typography } from '../../../../../typography';
import { variantToLineHeightMapping } from '../../../../../typography/typography-utils';
import { getMeasureText } from '../../../column-util/object-table-column-util';
import { RowHeight } from '../../../object-table.interface';
import styles from '../primary-column.module.scss';
export const PrimaryContentComponent = ({ primaryUrl, primaryText, primaryTextOnClick, secondaryText, onMoreClick, rowHeight, setRowHeight, }) => {
    const { t } = useTranslation();
    const [showMore, setShowMore] = useState(false);
    const containerRef = useRef(null);
    const primaryRef = useRef(null);
    const onRowNameClicked = (e) => {
        if (e.metaKey || e.ctrlKey) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(primaryUrl, '_blank', 'noopener');
        }
        else {
            primaryTextOnClick();
        }
        e.preventDefault();
    };
    const onRowNameSelected = (e) => {
        if (e.key === Key.Enter) {
            onRowNameClicked(e);
        }
    };
    const prepareDimensions = () => {
        if (rowHeight !== RowHeight.Extended) {
            if (secondaryText === '') {
                setRowHeight(RowHeight.Default);
                return;
            }
            const primaryHeight = variantToLineHeightMapping['content-label-subhead'];
            const secondRowPresent = primaryHeight < (primaryRef === null || primaryRef === void 0 ? void 0 : primaryRef.current.offsetHeight);
            if (secondRowPresent) {
                setRowHeight(RowHeight.ThreeLines);
            }
            // To show more option for ellipsis to extended the content
            const padding = 12;
            const contentOffsetWidth = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.offsetWidth) - padding;
            const secondaryMeasureText = getMeasureText(secondaryText, '12px')
                .width;
            setShowMore(contentOffsetWidth < secondaryMeasureText);
        }
    };
    useEffect(() => {
        prepareDimensions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useResizeObserver(containerRef, () => {
        prepareDimensions();
    });
    return (React.createElement("div", { ref: containerRef, className: styles.fullWidth },
        React.createElement(Vertical, { className: cx(styles.cellContent, {
                [styles.cellHeight72]: rowHeight === RowHeight.Default,
                [styles.cellHeight80]: rowHeight === RowHeight.ThreeLines,
            }), vAlignContent: "center" },
            React.createElement("div", { className: styles.fullWidth, ref: primaryRef },
                React.createElement(Typography, { variant: "content-label-subhead", "data-testid": "primary-content-testid", className: styles.primaryText, tooltipConfig: {
                        dataTooltipContent: primaryText,
                    }, noMargin: true, ellipsis: {
                        rows: 2,
                    } },
                    React.createElement(Link, { className: styles.title, href: primaryUrl, onClick: onRowNameClicked, onKeyPress: onRowNameSelected, rel: "noreferrer" }, isHTML(primaryText) ? (React.createElement(SafeHTML, { html: primaryText })) : (primaryText)))),
            secondaryText !== '' && (React.createElement(Horizontal, { className: styles.fullWidth },
                React.createElement("div", { className: cx(styles.fullWidth, {
                        [styles.fullWidthMinusMoreWidth]: showMore,
                    }) },
                    React.createElement(Typography, { variant: "footnote", "data-testid": "secondary-testid", className: styles.secondaryText, noMargin: true, ellipsis: {
                            rows: 1,
                        } }, secondaryText)),
                showMore && (React.createElement("span", { className: styles.showMoreWrapper },
                    React.createElement(Typography, { variant: "footnote", "data-testid": "secondary-more-testid", className: styles.moreText, noMargin: true, onClick: onMoreClick }, t('ObjectTable.More')))))))));
};
//# sourceMappingURL=primary-content.component.js.map